import type { ItemFiltersType } from '@/common/api/types/itemFilters';
import { commonQueryKeys } from '@/common/queryKeys/common';

type TreeSetDescriptor = {
  __treeSet: true;
  order: string | undefined;
  includeDescendants: boolean;
};

export const itemsTreeSetQueryKey = ({
  filter,
  order,
  includeDescendants = false,
}: {
  filter?: ItemFiltersType;
  order?: string;
  includeDescendants?: boolean;
} = {}) =>
  [
    ...commonQueryKeys.itemsTreeSet.byFilter(filter),
    { __treeSet: true, order, includeDescendants } satisfies TreeSetDescriptor,
  ] as const;

const descriptorOf = (queryKey: readonly unknown[]): TreeSetDescriptor | null => {
  for (const segment of queryKey) {
    if (typeof segment !== 'object' || segment === null) continue;
    if ('__treeSet' in segment && segment.__treeSet === true) {
      return segment as TreeSetDescriptor;
    }
  }
  return null;
};

export const isTreeSetKey = ({ queryKey }: { queryKey: readonly unknown[] }): boolean =>
  descriptorOf(queryKey) !== null;

/** No order means priority order — the only variant an optimistic drag reorder can patch in place. */
export const isPriorityOrderedTreeSetKey = ({
  queryKey,
}: {
  queryKey: readonly unknown[];
}): boolean => {
  const descriptor = descriptorOf(queryKey);
  return descriptor !== null && !descriptor.order;
};
